import React from 'react';
import {
  LineChart, Line, BarChart, Bar, XAxis, YAxis,
  CartesianGrid, Tooltip, ResponsiveContainer,
} from 'recharts';
import type { QuestionWithData } from '../services/pracmagicTypes';

const QuestionChart = ({ q }: { q: QuestionWithData }) => {
  if (q.data_points.length === 0) {
    return <p className="text-xs text-gray-400 italic py-2">No responses yet.</p>;
  }

  if (q.type === 'rating' || q.type === 'number') {
    const isRating = q.type === 'rating';
    // Use index as x-key so same-day responses render as distinct points
    const data = q.data_points.map((dp, i) => ({
      x: i,
      dateLabel: dp.submitted_at.slice(0, 10),
      value: dp.rating_value,
    }));
    return (
      <ResponsiveContainer width="100%" height={160}>
        <LineChart data={data} margin={{ top: 4, right: 8, bottom: 4, left: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis dataKey="x" tickFormatter={(v) => data[v as number]?.dateLabel ?? ''} tick={{ fontSize: 10 }} />
          <YAxis
            domain={isRating ? [1, 5] : ['auto', 'auto']}
            ticks={isRating ? [1, 2, 3, 4, 5] : undefined}
            allowDecimals={false}
            tick={{ fontSize: 10 }}
            width={20}
          />
          <Tooltip labelFormatter={(label) => data[label as number]?.dateLabel ?? String(label)} />
          <Line type="monotone" dataKey="value" stroke="#6366f1" strokeWidth={2} dot={{ r: 3 }} />
        </LineChart>
      </ResponsiveContainer>
    );
  }

  if (q.type === 'yesno') {
    const yesCount = q.data_points.filter(dp => dp.bool_value).length;
    const noCount  = q.data_points.filter(dp => !dp.bool_value).length;
    const data = [{ name: 'Yes', count: yesCount }, { name: 'No', count: noCount }];
    return (
      <ResponsiveContainer width="100%" height={120}>
        <BarChart data={data} margin={{ top: 4, right: 8, bottom: 4, left: 0 }}>
          <XAxis dataKey="name" tick={{ fontSize: 11 }} />
          <YAxis allowDecimals={false} tick={{ fontSize: 10 }} width={20} />
          <Tooltip />
          <Bar dataKey="count" fill="#6366f1" radius={[4, 4, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    );
  }

  // freetext
  return (
    <div className="space-y-2 max-h-48 overflow-y-auto">
      {q.data_points.map((dp, i) => (
        <div key={i} className="text-sm text-gray-700 bg-gray-50 rounded-lg px-3 py-2">
          <p className="text-xs text-gray-400 mb-1">{dp.submitted_at.slice(0, 10)}</p>
          <p>{dp.text_value}</p>
        </div>
      ))}
    </div>
  );
};

export default QuestionChart;
